import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/Globals.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleReCaptchaProvider } from '@google-recaptcha/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY
  ? `${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`
  : `6Le3Ji8rAAAAAONU4YuvX3mGhx38RKWuyEQilf3W`;
  
root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      type="v2-invisible"
      siteKey={recaptchaKey}
    >
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>
);

reportWebVitals();
